import React, { Component, createRef } from 'react'
import MaterialTable, { MTableBodyRow } from 'material-table'

import { EQuoteSailingsFullSearchPagination } from './EQuoteSailingsFullSearchPagination'

import EQuoteSailingsSelectPackageButton from '../Buttons/EQuoteSailingsSelectPackageButton'
import EQuoteSailingsFullSearchCabins from '../Cabins/EQuoteSailingsFullSearchCabins'

import moment from 'moment'
import EQuoteTablePriceCell from '../EQuoteTablePriceCell'
import EQuoteTablePreviewButtonCell from '../Buttons/EQuoteTablePreviewButtonCell'

import removeClassAllElements from '../../../../utilities/removeClassAllElements'
import getArrayElementsByClass from '../../../../utilities/getArrayElementsByClass'
import { connect } from 'react-redux'
import { getActivePackageKeys } from '../../../../reducers/setActivePackageReducers'
import { getPackagesDetails } from '../../../../reducers/fetchPackagesReducers'

const pricingCellStyles = {
  cellStyle: {
    paddingTop: 0,
    paddingBottom: 10,
    paddingLeft: 0,
    paddingRight: 0,
    width: 132,
    position: 'relative'
  },
  headerStyle: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 10,
    paddingRight: 10,
    width: 132,
    zIndex: 12
  }
}

let curPackageIdentifier = null
let curBg = 'secondary-background'

class EQuoteSailingsFullSearchCruisesTab extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.onOrderChangeFlag = false
    this.tableRef = createRef()
  }

  shouldComponentUpdate(nextProps) {
    /*
     * we need this to prevent the table from re-rendering if the click handlers
     * change (which they do on every parent update)
     * as that will cause the price cells to make duplicate ajax request
     * when using unsupportedQualifiers.
     * This currently causes the table to never update because it un-mounts
     * and remounts with every new search
     */
    curBg = 'secondary-background'
    curPackageIdentifier = null

    if (this.props.filterTerms !== nextProps.filterTerms) {
      this.tableRef &&
        this.tableRef.current &&
        this.tableRef.current.dataManager &&
        (this.tableRef.current.dataManager.currentPage = 0)
      return true
    }

    if (
      this.props.activeParentPackageKeys.length !==
        nextProps.activeParentPackageKeys.length ||
      this.props.activePackageKeys.length !== nextProps.activePackageKeys.length
    ) {
      return true
    }

    return false
  }

  onSetPageSize = size => {
    const { activeSearchFilterData, handleSetPageSize } = this.props
    const { perPage } = activeSearchFilterData
    if (perPage !== size) handleSetPageSize(size)
  }

  onPaginate = action => {
    const { activeSearchFilterData, handleSetPagination } = this.props
    const { page, pages, perPage, total } = activeSearchFilterData
    const pagination = {
      page,
      pages,
      perPage,
      total
    }

    switch (action) {
      case 'first':
        pagination.page = 1
        break

      case 'prev':
        pagination.page = Math.max(1, pagination.page - 1)
        break

      case 'next':
        pagination.page = Math.min(pages, pagination.page + 1)
        break

      case 'last':
        pagination.page = pages
        break

      default:
    }

    if (activeSearchFilterData.page !== pagination.page) {
      handleSetPagination(pagination)
    }
  }

  // On table change (e.g click in any cell header), simulate click on each previous row that has a
  // detail panel opened to call 'OnRowClick'
  onTableChange = (e, action) => {
    const rowsWithClassActive = getArrayElementsByClass(
      '.equote__sailings-full-search--table-body-row ~ tr:not(.equote__sailings-full-search--table-body-row)'
    )

    rowsWithClassActive.forEach(row => {
      this.onOrderChangeFlag = true
      const event = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      })
      //Remove all active price cells
      row.previousSibling.dispatchEvent(event)
    })
    removeClassAllElements(document, 'active-price')
    this.onChangePageScroll()
  }

  //Get the detail panel, simulate a click on the active cell to close the panel
  onRowClick = (event, rowData) => {
    const detailPanel =
      event.currentTarget.nextSibling &&
      event.currentTarget.nextSibling.querySelector(
        '.equote__sailings-full-search-cabins-table'
      )
    if (this.onOrderChangeFlag && detailPanel && detailPanel.dataset.type) {
      removeClassAllElements(event.currentTarget, 'active-price')
      this.props.toggleSuperClassDetails(rowData, detailPanel.dataset.type)
    }

    this.onOrderChangeFlag = false
  }

  onChangePageScroll = () => {
    const resultTable = document.querySelector(
      '.equote__sailings-full-search-table'
    )
    resultTable &&
      resultTable.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
  }

  renderDateCol = () => {
    const {
      activeSearchFilterData,
      handleOpenItineraryPreviewModal
    } = this.props

    if (activeSearchFilterData && activeSearchFilterData.sortBy === 'PRICE') {
      return {
        title: 'Date',
        field: 'departure',
        type: 'date',
        cellStyle: {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 10,
          paddingRight: 10,
          minWidth: 110,
          maxWidth: 110,
          border: 0
        },
        headerStyle: {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 10,
          paddingRight: 10,
          minWidth: 110,
          maxWidth: 110,
          zIndex: 12
        },
        render: rowData => {
          if (rowData.pricingType === 'Individual') {
            return (
              <button
                className="btn btn-text u-font-uppercase"
                onClick={() =>
                  handleOpenItineraryPreviewModal(
                    rowData.id,
                    rowData.sailDate,
                    rowData.brand,
                    rowData.identifier,
                    false
                  )
                }
              >
                {moment(rowData.startDate).format('DDMMMYYYY')}
              </button>
            )
          }
        }
      }
    } else {
      return {
        title: 'Date',
        field: 'departure',
        type: 'date',
        defaultSort: 'asc',
        cellStyle: {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 10,
          paddingRight: 10,
          minWidth: 110,
          maxWidth: 110,
          border: 0
        },
        headerStyle: {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 10,
          paddingRight: 10,
          minWidth: 110,
          maxWidth: 110,
          zIndex: 12
        },
        render: rowData => {
          if (rowData.pricingType === 'Individual') {
            return (
              <button
                className="btn btn-text u-font-uppercase"
                onClick={() =>
                  handleOpenItineraryPreviewModal(
                    rowData.id,
                    rowData.departure,
                    rowData.brand,
                    rowData.identifier,
                    false
                  )
                }
              >
                {moment(rowData.departure).format('DDMMMYYYY')}
              </button>
            )
          }
        }
      }
    }
  }

  getSuperCategoryFullName = (rowData, superCatCode) => {
    if (!rowData || !superCatCode) {
      return null
    }
    const pricing =
      rowData && rowData.pricing && rowData.pricing[superCatCode.toUpperCase()]
    return pricing && pricing.category && pricing.category.name
      ? pricing.category.name
      : pricing && pricing.stateroomDescription
  }

  showTaxes = rowData => {
    const targetRow = document.getElementById(`package-${rowData.identifier}`)
    targetRow.classList.remove('has-active-cell')
  }

  hideTaxes = rowData => {
    const targetRow = document.getElementById(`package-${rowData.identifier}`)
    targetRow.classList.add('has-active-cell')
  }

  render() {
    const {
      activePackageKeys,
      activeParentPackageKeys,
      packages,
      handleOpenShipModal,
      handleOpenPackageDetailsModal,
      toggleSuperClassDetails,
      activeSearchFilterData,
      setIsBundled
    } = this.props

    return (
      <MaterialTable
        tableRef={this.tableRef}
        onOrderChange={this.onTableChange}
        onRowClick={this.onRowClick}
        onChangePage={this.onTableChange}
        onChangeRowsPerPage={this.onTableChange}
        components={{
          Container: props => (
            <div className="equote__sailings-cruises-table u-table hide-details-icons hide-filter-row">
              {props.children}
            </div>
          ),
          Row: props => {
            let dividerClass =
              props?.data?.pricingType === 'Individual' ? 'row-color' : ''

            const isMuted =
              !activePackageKeys.includes(props?.data?.identifier) &&
              activeParentPackageKeys.includes(props?.data?.packageIdentifier)

            // Reset striping state at the start of each render pass. Needed
            // because MaterialTable re-renders rows internally (e.g. when a
            // detail panel opens via toggleSuperClassDetails) without going
            // through shouldComponentUpdate, so stale module-level state
            // would otherwise flip the first row's background.
            if (props?.index === 0) {
              curBg = 'secondary-background'
              curPackageIdentifier = null
            }

            if (
              props?.data?.packageIdentifier !== curPackageIdentifier &&
              curPackageIdentifier !== null
            ) {
              curBg =
                curBg === 'secondary-background' ? '' : 'secondary-background'
            }

            curPackageIdentifier = props?.data?.packageIdentifier

            return (
              <MTableBodyRow
                /**
                 * We need the secondary-background class because MaterialTable will add a new <tr />
                 * when we toggle open the details which makes nth-child unreliable
                 **/
                className={`equote__sailings-full-search--table-body-row primary-row ${dividerClass} package-${
                  props?.data.id
                }-${props?.data.departure} ${curBg} ${isMuted ? 'muted' : ''}`}
                id={`package-${props?.data.identifier}`}
                {...props}
              />
            )
          },
          Pagination: props => (
            <EQuoteSailingsFullSearchPagination
              {...props}
              searchFilterData={activeSearchFilterData}
              onPaginate={this.onPaginate}
              onSetPageSize={this.onSetPageSize}
            />
          )
        }}
        options={{
          paging: true,
          pageSize: packages.length,
          showEmptyDataSourceMessage: true,
          toolbar: false,
          filtering: true,
          // paginationType: 'stepped',
          emptyRowsWhenPaging: false
        }}
        localization={{
          body: {
            emptyDataSourceMessage:
              'No sailings available, please try another date range.'
          }
        }}
        columns={[
          {
            title: 'Brand',
            field: 'brand',
            defaultFilter:
              this.props.filterTerms.brand === 'C,R'
                ? ''
                : this.props.filterTerms.brand,
            cellStyle: {
              display: 'none'
            },
            headerStyle: {
              display: 'none'
            }
          },
          this.renderDateCol(),
          {
            title: 'Nights',
            defaultFilter: this.props.filterTerms.nights,
            field: 'nights',
            type: 'numeric',
            cellStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              margin: 'auto',
              minWidth: 0,
              maxWidth: 98,
              border: 0
            },
            headerStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 0,
              maxWidth: 98,
              zIndex: 12
            },
            render: packageData => {
              if (packageData.pricingType === 'Individual')
                return packageData.nights
            }
          },
          {
            title: 'Destination',
            defaultFilter: this.props.filterTerms.destination,
            field: 'destinationCode',
            cellStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 0,
              border: 0
            },
            headerStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 0,
              zIndex: 12
            },
            render: rowData => {
              if (rowData.pricingType === 'Individual') {
                return <div>{rowData.destinationName}</div>
              }
            }
          },
          {
            title: 'Ship',
            defaultFilter: this.props.filterTerms.ship,
            field: 'shipCode',
            cellStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 112,
              border: 0
            },
            headerStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 112,
              zIndex: 12
            },
            render: rowData => {
              if (rowData.pricingType === 'Individual')
                return (
                  <button
                    onClick={() => handleOpenShipModal(rowData.shipCode)}
                    className="btn btn-text"
                    tabIndex={0}
                  >
                    {rowData.shipName}
                  </button>
                )
            }
          },
          {
            title: 'Voyage',
            defaultFilter:
              this.props.filterTerms.voyageType === 'O,V'
                ? ''
                : this.props.filterTerms.voyageType,
            field: 'voyageType',
            cellStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 75,
              borderBottom: 0
            },
            headerStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 75,
              zIndex: 12
            },
            render: rowData => {
              if (rowData.pricingType === 'Individual')
                return rowData.voyageType
            }
          },
          {
            title: 'Select up to 5',
            field: 'id',
            sorting: false,
            cellStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              textAlign: 'center',
              minWidth: 0,
              maxWidth: 90,
              width: 90
            },
            headerStyle: {
              padding: 20,
              minWidth: 0,
              maxWidth: 90,
              width: 90,
              zIndex: 12
            },
            render: packageData => {
              return (
                <EQuoteSailingsSelectPackageButton
                  identifier={packageData.identifier}
                  packageIdentifier={packageData.packageIdentifier}
                  isLandPackage={false}
                  stateKey={packageData.stateKey}
                  isCruiseTour={!packageData.justACruise}
                />
              )
            }
          },
          {
            title: 'Pricing',
            field: 'pricingType',
            cellStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 100
            },
            headerStyle: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 10,
              paddingRight: 10,
              minWidth: 100,
              zIndex: 12
            },
            render: rowData => {
              return (
                <div className="equote__sailings-table-pricing-cell">
                  {rowData.pricingType !== 'Group' && (
                    <span className=".equote__sailings-table-pricing-type">
                      {rowData.pricingType}:
                    </span>
                  )}
                  {rowData.pricingType === 'Group' && (
                    <>
                      <span className=".equote__sailings-table-pricing-type">
                        {rowData.headquarterGroupFlag === 'Yes'
                          ? 'HQ Group'
                          : 'Trad. Group'}
                        :
                      </span>
                      <span className="equote__sailings-table-pricing-group-id">
                        {rowData?.groupName ? rowData.groupName : ''}
                      </span>
                      <span className="equote__sailings-table-pricing-group-id">
                        #{rowData.groupId}
                      </span>
                    </>
                  )}
                </div>
              )
            }
          },
          {
            title: 'Interior',
            field: 'interiorCategoryData',
            type: 'numeric',
            sorting: false,
            ...pricingCellStyles,
            render: rowData => {
              const stateroomExists = rowData.stateroomTypes
                ? rowData.stateroomTypes.find(
                    stateRoom => stateRoom.code === 'I'
                  )
                : null

              return (
                <EQuoteTablePriceCell
                  packageIdentifier={rowData.identifier}
                  isCruiseTour={false}
                  stateroomType={'I'}
                  shipCode={rowData.shipCode}
                  onClick={() => {
                    toggleSuperClassDetails(rowData, 'interior')
                  }}
                  setIsBundled={setIsBundled}
                  stateroomExists={stateroomExists}
                />
              )
            }
          },
          {
            title: 'Oceanview',
            field: 'oceanviewCategoryData',
            type: 'numeric',
            sorting: false,
            ...pricingCellStyles,
            render: rowData => {
              const stateroomExists = rowData.stateroomTypes
                ? rowData.stateroomTypes.find(
                    stateRoom => stateRoom.code === 'O'
                  )
                : null
              return (
                <EQuoteTablePriceCell
                  packageIdentifier={rowData.identifier}
                  isCruiseTour={false}
                  stateroomType={'O'}
                  onClick={() => {
                    toggleSuperClassDetails(rowData, 'ocean')
                  }}
                  setIsBundled={setIsBundled}
                  stateroomExists={stateroomExists}
                />
              )
            }
          },
          {
            title: 'Balcony',
            field: 'balconyCategoryData',
            type: 'numeric',
            sorting: false,
            ...pricingCellStyles,
            render: rowData => {
              const stateroomExists = rowData.stateroomTypes
                ? rowData.stateroomTypes.find(
                    stateRoom => stateRoom.code === 'B'
                  )
                : null
              return (
                <EQuoteTablePriceCell
                  packageIdentifier={rowData.identifier}
                  isCruiseTour={false}
                  stateroomType={'B'}
                  onClick={() => {
                    toggleSuperClassDetails(rowData, 'balcony')
                  }}
                  setIsBundled={setIsBundled}
                  stateroomExists={stateroomExists}
                />
              )
            }
          },
          {
            title: 'Deluxe / Suite',
            field: 'suiteCategoryData',
            type: 'numeric',
            sorting: false,
            ...pricingCellStyles,
            render: rowData => {
              const stateroomExists = rowData.stateroomTypes
                ? rowData.stateroomTypes.find(
                    stateRoom => stateRoom.code === 'D'
                  )
                : null

              return (
                <EQuoteTablePriceCell
                  packageIdentifier={rowData.identifier}
                  isCruiseTour={false}
                  stateroomType={'D'}
                  onClick={() => {
                    toggleSuperClassDetails(rowData, 'deluxe')
                  }}
                  setIsBundled={setIsBundled}
                  stateroomExists={stateroomExists}
                />
              )
            }
          },
          {
            title: '',
            field: 'preview',
            loadingType: 'linear',
            sorting: false,
            cellStyle: {
              padding: '0 10px',
              textAlign: 'center',
              minWidth: 50
            },
            headerStyle: {
              padding: '0 10px',
              minWidth: 50,
              zIndex: 12
            },
            render: rowData => {
              const {
                id,
                departure,
                brand,
                destinationCode,
                identifier,
                justACruise,
                groupId
              } = rowData
              return (
                <EQuoteTablePreviewButtonCell
                  identifier={identifier}
                  justACruise={justACruise}
                  onClick={() =>
                    handleOpenPackageDetailsModal(
                      groupId ?? id,
                      departure,
                      brand,
                      destinationCode,
                      undefined,
                      undefined,
                      identifier
                    )
                  }
                />
              )
            }
          }
        ]}
        data={packages}
        detailPanel={[
          {
            icon: () => <span className="interior-icon-inner-span">i</span>,
            render: rowData => {
              this.hideTaxes(rowData)

              return (
                <div
                  style={{
                    backgroundColor: (() => {
                      const el = document.getElementById(
                        `package-${rowData.identifier}`
                      )
                      return el && getComputedStyle(el).backgroundColor
                    })()
                  }}
                >
                  <EQuoteSailingsFullSearchCabins
                    key={rowData.id + '-INTERIOR-' + rowData.departure}
                    superCategory="I"
                    superCategoryFullName={this.getSuperCategoryFullName(
                      rowData,
                      'I'
                    )}
                    type="interior"
                    packageData={rowData}
                    stateKey="packagesData"
                    keyIdentifier="-INTERIOR-"
                    closeHandler={() => {
                      removeClassAllElements(
                        document.getElementById(
                          `package-${rowData.identifier}`
                        ),
                        'active-price'
                      )
                      this.showTaxes(rowData)
                      toggleSuperClassDetails(rowData, 'interior')
                    }}
                  />
                </div>
              )
            }
          },
          {
            icon: () => <span className="ocean-icon-inner-span">o</span>,
            render: rowData => {
              this.hideTaxes(rowData)

              return (
                <div
                  style={{
                    backgroundColor: (() => {
                      const el = document.getElementById(
                        `package-${rowData.identifier}`
                      )
                      return el && getComputedStyle(el).backgroundColor
                    })()
                  }}
                >
                  <EQuoteSailingsFullSearchCabins
                    key={rowData.id + '-OUTSIDE-' + rowData.departure}
                    superCategory="O"
                    superCategoryFullName={this.getSuperCategoryFullName(
                      rowData,
                      'O'
                    )}
                    type="ocean"
                    packageData={rowData}
                    stateKey="packagesData"
                    keyIdentifier="-OUTSIDE-"
                    closeHandler={() => {
                      removeClassAllElements(
                        document.getElementById(
                          `package-${rowData.identifier}`
                        ),
                        'active-price'
                      )
                      this.showTaxes(rowData)
                      toggleSuperClassDetails(rowData, 'ocean')
                    }}
                  />
                </div>
              )
            }
          },
          {
            icon: () => <span className="balcony-icon-inner-span">b</span>,
            render: rowData => {
              this.hideTaxes(rowData)
              return (
                <div
                  style={{
                    backgroundColor: (() => {
                      const el = document.getElementById(
                        `package-${rowData.identifier}`
                      )
                      return el && getComputedStyle(el).backgroundColor
                    })()
                  }}
                >
                  <EQuoteSailingsFullSearchCabins
                    key={rowData.id + '-BALCONY-' + rowData.departure}
                    superCategory="B"
                    superCategoryFullName={this.getSuperCategoryFullName(
                      rowData,
                      'B'
                    )}
                    type="balcony"
                    packageData={rowData}
                    stateKey="packagesData"
                    keyIdentifier="-BALCONY-"
                    closeHandler={() => {
                      removeClassAllElements(
                        document.getElementById(
                          `package-${rowData.identifier}`
                        ),
                        'active-price'
                      )
                      this.showTaxes(rowData)
                      toggleSuperClassDetails(rowData, 'balcony')
                    }}
                  />
                </div>
              )
            }
          },
          {
            icon: () => <span className="deluxe-icon-inner-span">d</span>,
            render: rowData => {
              this.hideTaxes(rowData)
              return (
                <div
                  style={{
                    backgroundColor: (() => {
                      const el = document.getElementById(
                        `package-${rowData.identifier}`
                      )
                      return el && getComputedStyle(el).backgroundColor
                    })()
                  }}
                >
                  <EQuoteSailingsFullSearchCabins
                    key={rowData.id + '-DELUXE-' + rowData.departure}
                    superCategory="D"
                    superCategoryFullName={this.getSuperCategoryFullName(
                      rowData,
                      'D'
                    )}
                    type="deluxe"
                    packageData={rowData}
                    stateKey="packagesData"
                    keyIdentifier="-DELUXE-"
                    closeHandler={() => {
                      removeClassAllElements(
                        document.getElementById(
                          `package-${rowData.identifier}`
                        ),
                        'active-price'
                      )
                      this.showTaxes(rowData)
                      toggleSuperClassDetails(rowData, 'deluxe')
                    }}
                  />
                </div>
              )
            }
          }
        ]}
      />
    )
  }
}

function mapStateToProps(state, ownProps) {
  const activePackageKeys = getActivePackageKeys(state)
  const activeParentPackageKeys = activePackageKeys.map(
    key => getPackagesDetails(state, false, key).packageIdentifier
  )
  return {
    ...ownProps,
    activePackageKeys,
    activeParentPackageKeys
  }
}

export default connect(mapStateToProps)(EQuoteSailingsFullSearchCruisesTab)
